module.exports = __webpack_public_path__ + "static/media/write-check.41adf193.jpg";